// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "PercentageBadge__textCenter__v4-No";
export const percentageBadge = "PercentageBadge__percentageBadge__DJ+bE";
export const warning = "PercentageBadge__warning__mMbFa";
export const svgContainer = "PercentageBadge__svgContainer__bAYdC";
export const labels = "PercentageBadge__labels__JAMwa";
export const shrinkText = "PercentageBadge__shrinkText__EE9FO";
export const slash = "PercentageBadge__slash__QvJYy";
export const stroke = "PercentageBadge__stroke__UNy0l";
export const background = "PercentageBadge__background__FteeF";